import React, { PureComponent } from 'react'
import { Determinator, withLang } from 'react-multi-language';
import BurgerMenu from 'react-burger-menu'
import { TweenMax } from 'gsap';
import { Bounce, LightSpeed, Zoom, Slide, Fade, Roll } from 'react-reveal';

import Button from 'components/Button';
import Header from 'components/Header';
import './style.scss';


class MenuWrap extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      hidden: false
    };
  }

  componentWillReceiveProps(nextProps) {
    const sideChanged = this.props.children.props.right !== nextProps.children.props.right;

    if (sideChanged) {
      this.setState({ hidden: true });

      setTimeout(() => {
        this.show();
      }, this.props.wait);
    }
  }

  show() {
    this.setState({ hidden: false });
  }

  render() {
    let style;

    if (this.state.hidden) {
      style = { display: 'none' };
    }

    return (
      <div style={style} className={this.props.side}>
        {this.props.children}
      </div>
    );
  }
}

class MobileNoLang extends PureComponent {
  why1 = null;
  why2 = null;
  why3 = null;
  why4 = null;
  why5 = null;
  why6 = null;

  ref1 = null;
  ref2 = null;
  ref3 = null;
  ref4 = null;

  one = {
    title: null,
  };

  two = {
    title: null,
  };

  state = {
    isMenuOpen: false,
    sectionFour: 0
  };

  mainAccountRefs = {
    clientIcon: null,
    title: null,
    description: null,
    button: null,
    topRight: null,
    topLeft: null,
    bottomLeft: null,
    bottomRight: null
  }

  componentDidMount() {
    this.animateSectionSix();
    this.animateSectionSeven();
    setTimeout(this.initAnimationOne, 200);
  }

  sectionFourNext = () => {
    if (this.state.sectionFour !== 2) {
      this.setState({
        sectionFour: this.state.sectionFour + 1
      });
    } else {
      this.setState({
        sectionFour: 0
      });
    }
  }

  animateSectionSix = () => {
    TweenMax.to(
      this.mainAccountRefs.clientIcon,
      0.9,
      {
        opacity: 1,
        transform: 'scale(1)',
        ease: 'Bounce.easeOut'
      }
    );
    setTimeout(() => {
      TweenMax.to(
        this.mainAccountRefs.topRight,
        0.4,
        {
          opacity: '1'
        }
      );
    }, 200);
    setTimeout(() => {
      TweenMax.to(
        this.mainAccountRefs.bottomLeft,
        0.4,
        {
          opacity: '1'
        }
      );
    }, 300);
    setTimeout(() => {
      TweenMax.to(
        this.mainAccountRefs.topLeft,
        0.4,
        {
          opacity: '1'
        }
      );
    }, 400);
    setTimeout(() => {
      TweenMax.to(
        this.mainAccountRefs.bottomRight,
        0.4,
        {
          opacity: '1'
        }
      );
    }, 500);

    setTimeout(() => {
      TweenMax.to(
        this.mainAccountRefs.description,
        0.3,
        {
          transform: 'translateX(0%)'
        }
      );
    }, 300);
    setTimeout(() => {
      TweenMax.to(
        this.mainAccountRefs.button,
        0.3,
        {
          transform: 'translateX(0%)'
        }
      );
    }, 400);
  }

  animateSectionSeven = () => {
    setTimeout(() => {
      TweenMax.to(
        this.ref1,
        .3,
        {
          opacity: 1
        }
      );
    }, 300);
    setTimeout(() => {
      TweenMax.to(
        this.ref2,
        .3,
        {
          opacity: 1
        }
      );
    }, 500);
    setTimeout(() => {
      TweenMax.to(
        this.ref3,
        .3,
        {
          opacity: 1
        }
      );
    }, 700);
    setTimeout(() => {
      TweenMax.to(
        this.ref4,
        .3,
        {
          opacity: 1
        }
      );
    }, 900);
  }

  toggleMenu = () => {
    this.setState(({ isMenuOpen }) => ({ isMenuOpen: !isMenuOpen }));
  }

  getMenu() {
    const Menu = BurgerMenu.elastic;

    return (
      <MenuWrap wait={20} side="left">
        <Menu
          id={'scaleDown'}
          pageWrapId={'page-wrap'}
          outerContainerId={'outer-container'}
          customBurgerIcon={false}
          isOpen={this.state.isMenuOpen}
        >
          <div style={{ height: 33, marginBottom: 30 }} className="logo">
            <img src={process.env.PUBLIC_URL + '/mobile/Logo.svg'} />
          </div>
          <div className="menu-item">
            <a className="link" target="_blank" href="https://dash.billtrade.io">Login</a>
          </div>
          <div className="menu-item">
            <a className="link" target="_blank" href="https://dash.billtrade.io">Sign Up</a>
          </div>
          <div className="menu-item">
            <div className="link">
              <a className="link" target="_blank" href="/Wiki.pdf">Wiki</a>
            </div>
          </div>
          <div className="menu-item">
            <div className="link">
              <a className="link" target="_blank" href="/Terms.pdf">Terms & conditions</a>
            </div>
          </div>
          <div className="menu-item">
            <div className="link">
              <a className="link" target="_blank" href="/Privacy.pdf">Privacy Policy</a>
            </div>
          </div>
        </Menu>
      </MenuWrap>
    );
  }

  initAnimationOne = () => {
    TweenMax.to(
      this.one.title,
      1.5,
      {
        ease: 'Elastic.easeOut',
        opacity: 1,
        transform: 'translate(0px, 0px)'
      }
    );
    TweenMax.to(
      this.one.subtitle,
      1.5,
      {
        ease: 'Elastic.easeOut',
        opacity: 1,
        transform: 'translate(0px, 0px)'
      }
    );
    TweenMax.to(
      this.one.button,
      1.8,
      {
        ease: 'Elastic.easeOut',
        opacity: 1,
        transform: 'translate(0px, 0px)'
      }
    );
    // setTimeout(() => {
    //   TweenMax.to(
    //     this.one.menu,
    //     1,
    //     {
    //       ease: 'Elastic.easeOut',
    //       transform: 'translate(0px, 0px)'
    //     }
    //   );
    // }, 200);
  }
  initAnimationTwo = () => {
    TweenMax.to(
      this.two.title,
      1,
      {
        ease: 'Elastic.easeOut',
        opacity: 1,
        transform: 'translate(0px, 0px)'
      }
    );
    setTimeout(() => {
      TweenMax.to(
        this.two.item1,
        1,
        {
          ease: 'Elastic.easeOut',
          opacity: 1,
          transform: 'translate(0px, 0px)'
        }
      );
    }, 300);
    setTimeout(() => {
      TweenMax.to(
        this.two.item2,
        1,
        {
          ease: 'Elastic.easeOut',
          opacity: 1,
          transform: 'translate(0px, 0px)'
        }
      );
    }, 350);
    setTimeout(() => {
      TweenMax.to(
        this.two.item3,
        1,
        {
          ease: 'Elastic.easeOut',
          opacity: 1,
          transform: 'translate(0px, 0px)'
        }
      );
    }, 400);
    setTimeout(() => {
      TweenMax.to(
        this.two.button,
        1,
        {
          ease: 'Elastic.easeOut',
          opacity: 1,
          transform: 'translate(0px, 0px)'
        }
      );
    }, 500);
  }

  render() {
    const {
      areaPlaceholder,
      emailPlaceholder,
      items
    } = this.props.langProps;

    const {
      isMenuOpen,
      sectionFour
    } = this.state;

    console.log(items);

    return (
      <div id="outer-container" className="c_app">
        {this.getMenu()}
        <main id="page-wrap">
          <Header toggleMenu={this.toggleMenu} />

          <section className="one fpad fcol">
            <svg className="background" width="378.645" height="557.283" viewBox="0 0 378.645 557.283">
              <defs>
                <linearGradient id="gradient-1" x1="0.5" x2="0.5" y2="1.453" gradientUnits="objectBoundingBox">
                  <stop offset="0" stopColor="#202020"/>
                  <stop offset="1" stopColor="#6a6a6a"/>
                </linearGradient>
              </defs>
              <path id="BT" d="M137.7,500.66v-309.4H259.69q46.41,0,74.256,23.647t27.846,64.311q0,38.9-28.731,61.438,38.9,22.984,38.9,69.395,0,41.1-28.288,65.858T268.087,500.66Zm79.118-70.719h49.062q11.934,0,19.448-7.294t7.514-18.785q0-11.934-7.514-19.006t-19.448-7.072H216.815Zm0-119.34h40.664a26.153,26.153,0,0,0,17.9-6.41q7.294-6.408,7.294-17.9,0-11.05-7.072-17.68t-18.122-6.63H216.815Zm143.942-57.823V19.843H284.292V-56.623H516.343V19.843H439.876V252.778Z" transform="translate(-137.697 56.623)" fill="url(#gradient-1)"/>
            </svg>

            <div className="flex"></div>

            <div className="flex df fcol">
              <div
                className="title"
                ref={ref => { this.one.title = ref }}
              >
                <svg width="232" height="234" viewBox="0 0 242 234">
                  <text id="Veni_Vidi_Copy" transform="translate(0 60)" fill="#fff" fontFamily="Gilroy-Heavy, Gilroy" fontWeight="800" letterSpacing="0.05em">
                    <tspan x="0" y="0">Veni </tspan>
                    <tspan x="25" y="78" space="preserve"> Vidi </tspan>
                    <tspan x="35" y="150" space="preserve">  Copy</tspan>
                  </text>
                </svg>
              </div>
              <div
                  className="subtitle"
                  ref={ref => { this.one.subtitle = ref }}
                >
                  <Determinator>
                    {{
                      en: 'Copy the trades of successful traders',
                      ru: 'Копируйте сделки успешных трейдеров'
                    }}
                  </Determinator>
                </div>
            </div>

            <div className="flex fcol fcenter fevenly">
              <div className="text">The services of the platform are working privately, those who want to use them are welcome to <b>sign up</b> and <b>submit the application</b></div>
              <div className="button" ref={ref => { this.one.button = ref }}>
                <a target="_blank" href="https://dash.billtrade.io">
                  <Button>
                    <Determinator>
                      {{
                        en: 'Start now',
                        ru: 'Подключиться'
                      }}
                    </Determinator>
                  </Button>
                </a>
              </div>
            </div>
          </section>

          <section className="two fpad fcol">
            <div
              className="bt"
              style={{
                backgroundImage: `url(${process.env.PUBLIC_URL} /mobile/benefits-bt.svg)`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center center',
                position: 'absolute',
                bottom: 0,
                left: 0,
                right: 0,
                margin: 'auto',
                width: 99,
                height: 267,
                zIndex: 20
              }}
            />

            <div className="flex align-center">
              <div
                className="title"
                ref={ref => { this.two.title = ref }}
              >
                <Determinator>
                  {{
                    en: 'What can you get with Bill Trade?',
                    ru: 'Что вы можете получить с Bill Trade?'
                  }}
                </Determinator>
              </div>
            </div>

            <div className="flex align-center">
              <div className="body">
                <div ref={ref => { this.two.item1 = ref }} className="item">
                  <Determinator>
                    {{
                      en: 'Best traders in the industry',
                      ru: 'Лучшие трейдеры в индустрии'
                    }}
                  </Determinator>
                </div>
                <div ref={ref => { this.two.item2 = ref }} className="item">
                  <Determinator>
                    {{
                      en: 'Best security for your assets',
                      ru: 'Безопасность ваших активов'
                    }}
                  </Determinator>
                </div>
                <div ref={ref => { this.two.item3 = ref }} className="item">
                  <Determinator>
                    {{
                      en: 'Best additional income',
                      ru: 'Лучший дополнительный доход'
                    }}
                  </Determinator>
                </div>
              </div>
            </div>

            <div className="flex align-center">
              <div className="button" ref={ref => { this.two.button = ref }}>
                <Bounce left duration={600}>
                  <a target="_blank" href="https://dash.billtrade.io">
                    <Button>
                      <Determinator>
                        {{
                          en: 'Open free account',
                          ru: 'Узнать больше'
                        }}
                      </Determinator>
                    </Button>
                  </a>
                </Bounce>
              </div>
            </div>

          </section>

          <section className="three">
            <div className="title">
              <div className="lg">
                <Determinator>
                  {{
                    en: `How does it work?`,
                    ru: `Как это работает?`,
                  }}
                </Determinator>
              </div>
              <div className="sm">
                <Determinator>
                  {{
                    en: `5 easy steps to work with bill trade`,
                    ru: `5 простых шагов для работы с Bill Trade`,
                  }}
                </Determinator>
              </div>
            </div>

            <div className="body">
              <div className="item">
                <div className="lg">
                  <Determinator>
                    {{
                      en: `Sign up`,
                      ru: `Зарегистрируйтесь`,
                      ar: ``,
                      fr: ``
                    }}
                  </Determinator>
                </div>
                <div className="sm">
                  <Determinator>
                    {{
                      en: `Join Bill Trade`,
                      ru: `присоединяйтесь к Bill Trade`,
                      ar: ``,
                      fr: ``
                    }}
                  </Determinator>
                </div>
              </div>
              <div className="item">
                <div className="lg">
                  <Determinator>
                    {{
                      en: `Add API keys`,
                      ru: `Добавьте API ключи`,
                      ar: ``,
                      fr: ``
                    }}
                  </Determinator>
                </div>
                <div className="sm">
                  <Determinator>
                    {{
                      en: `Add the API key from the exchange that stores your assets`,
                      ru: `Добавьте API-ключ от биржи, в которой хранятся ваши активы`,
                      ar: ``,
                      fr: ``
                    }}
                  </Determinator>
                </div>
              </div>
              <div className="item">
                <div className="lg">
                  <Determinator>
                    {{
                      en: `Watch Ranks`,
                      ru: `Смотрите рейтинги`,
                      ar: ``,
                      fr: ``
                    }}
                  </Determinator>
                </div>
                <div className="sm">
                  <Determinator>
                    {{
                      en: `Bill Trade compiles trading statistics and ranks our top traders`,
                      ru: `BillTrade собирает статистику торговли и оценивает наших лучших трейдеров`,
                      ar: ``,
                      fr: ``
                    }}
                  </Determinator>
                </div>
              </div>
              <div className="item">
                <div className="lg">
                  <Determinator>
                    {{
                      en: `Compare and Follow`,
                      ru: `Оцените лучших`,
                      ar: ``,
                      fr: ``
                    }}
                  </Determinator>
                </div>
                <div className="sm">
                  <Determinator>
                    {{
                      en: `Investors choose leading traders to follow and get profit`,
                      ru: `Инвесторы выбирают лидеров, чтобы следовать и получать прибыль`,
                      ar: ``,
                      fr: ``
                    }}
                  </Determinator>
                </div>
              </div>
              <div className="item">
                <div className="lg">
                  <Determinator>
                    {{
                      en: `Copy Deals`,
                      ru: `Копируйте сделки`,
                      ar: ``,
                      fr: ``
                    }}
                  </Determinator>
                </div>
                <div className="sm">
                  <Determinator>
                    {{
                      en: `Experienced traders make successful trades which others can copy`,
                      ru: `Профессионалы совершают успешные сделки, которые могут быть скопированны другими`,
                      ar: ``,
                      fr: ``
                    }}
                  </Determinator>
                </div>
              </div>
            </div>
          </section>

          <section className="four" onClick={this.sectionFourNext}>
            <svg className="slider" xmlns="http://www.w3.org/2000/svg" width="27.237" height="503" viewBox="0 0 27.237 503">
              <g id="Group_2709" transform="translate(-15.263 -2080)">
                <path id="Path_3931" d="M0,0V500" transform="translate(41 2081.5)" fill="none" stroke="#ff4500" strokeLinecap="round" strokeWidth="3" />
                <g id="Group_2703" transform="translate(-424.5 2008)">
                  <line id="Line_547" x2="15.737" transform="translate(439.763 313)" fill="none" stroke={sectionFour === 0 ? '#393a3e' : '#cdcdce'} strokeWidth={sectionFour === 0 ? 2 : 1} />
                  <line id="Line_549" x2="9.737" transform="translate(439.763 323)" fill="none" stroke={sectionFour === 1 ? '#393a3e' : '#cdcdce'} strokeWidth={sectionFour === 1 ? 2 : 1} />
                  <line id="Line_548" x2="9.737" transform="translate(439.763 333)" fill="none" stroke={sectionFour === 2 ? '#393a3e' : '#cdcdce'} strokeWidth={sectionFour === 2 ? 2 : 1} />
                </g>
              </g>
            </svg>

            <div className="item with-title">
              <Zoom right>
                <div className="title">
                  {items && items[sectionFour].title}
                  <div className="desc">
                  Trade without barriers
                  </div>
                </div>
              </Zoom>
            </div>
            <div className="item">
              <Zoom right>
                <div className="item top">
                  <div className="item-title">
                    {items && items[sectionFour].top.title}
                  </div>
                  <div className="item-subtitle">
                    {items && items[sectionFour].top.subtitle}
                  </div>
                </div>
              </Zoom>
              <Zoom right>
                <div className="item bot">
                  <div className="item-title">
                    {items && items[sectionFour].bottom.title}
                  </div>
                  <div className="item-subtitle">
                    {items && items[sectionFour].bottom.subtitle}
                  </div>
                </div>
              </Zoom>
            </div>
          </section>

          <section className="five">
            <Fade left duration={1000}>
              <div className="title">
                <Determinator>
                  {{
                    en: 'Why investors choose Bill Trade?',
                    ru: 'Почему инвесторы выбирают Bill Trade?'
                  }}
                </Determinator>
              </div>
            </Fade>
            <Slide cascade left duration={500}>
              <div className="body">
                <div
                  className="item"
                >
                  <div
                    className="item__tile"
                    ref={ref => { this.why1 = ref }}
                  >
                    <div className="item__tile__icon"><img src={process.env.PUBLIC_URL + '/why-one.svg'} /></div>
                    <div className="item__tile__description">
                      <Determinator>
                        {{
                          en: `Transparent trading history`,
                          ru: `Прозрачная история торговли`,
                        }}
                      </Determinator>
                    </div>
                  </div>
                  <div
                    className="item__tile"
                    ref={ref => { this.why2 = ref }}
                  >
                    <div className="item__tile__icon"><img src={process.env.PUBLIC_URL + '/why-four.svg'} /></div>
                    <div className="item__tile__description">
                      <Determinator>
                        {{
                          en: `Automated and accurate statistics about traders`,
                          ru: `Автоматическая и точная статистика трейдеров`,
                        }}
                      </Determinator>
                    </div>
                  </div>
                </div>
                <div
                  className="item"
                >
                  <div
                    className="item__tile"
                    ref={ref => { this.why3 = ref }}
                  >
                    <div className="item__tile__icon"><img src={process.env.PUBLIC_URL + '/why-two.svg'} /></div>
                    <div className="item__tile__description">
                      <Determinator>
                        {{
                          en: `No trading skills needed to copy trade`,
                          ru: `Не нужно быть специалистом чтобы копировать сделки`,
                        }}
                      </Determinator>
                    </div>
                  </div>
                  <div
                    className="item__tile"
                    ref={ref => { this.why4 = ref }}
                  >
                    <div className="item__tile__icon"><img src={process.env.PUBLIC_URL + '/why-five.svg'} /></div>
                    <div className="item__tile__description">
                      <Determinator>
                        {{
                          en: `Free access to all features`,
                          ru: `Бесплатный доступ ко всем функциям платформы`,
                        }}
                      </Determinator>
                    </div>
                  </div>
                </div>
                <div
                  className="item"
                >
                  <div
                    className="item__tile"
                    ref={ref => { this.why5 = ref }}
                  >
                    <div className="item__tile__icon"><img src={process.env.PUBLIC_URL + '/why-three.svg'} /></div>
                    <div className="item__tile__description">
                      <Determinator>
                        {{
                          en: `Effective risk management`,
                          ru: `Эффективный риск менеджмент`,
                        }}
                      </Determinator>
                    </div>
                  </div>
                  <div
                    className="item__tile"
                    ref={ref => { this.why6 = ref }}
                  >
                    <div className="item__tile__icon"><img src={process.env.PUBLIC_URL + '/why-six.svg'} /></div>
                    <div className="item__tile__description">
                      <Determinator>
                        {{
                          en: `No fee before you get profit`,
                          ru: `Никаких комиссий до получения прибыли`,
                        }}
                      </Determinator>
                    </div>
                  </div>
                </div>
              </div>
            </Slide>
          </section>

          <section className="six fcol fpad">
            <Fade delay={600} left duration={1000}>
              <div className="title flex justify-center align-center">
                <Determinator>
                  {{
                    en: 'One account many traders',
                    ru: 'Один аккаунт много трейдеров'
                  }}
                </Determinator>
              </div>
            </Fade>
            <Fade delay={600} left duration={1000}>
              <div className="description">
                <Determinator>
                  {{
                    en: `You no longer need to have many accounts
                    in to copy several traders or trade
                    yourself - trade, copy, diversify on a single account`,
                    ru: `Вам больше не нужно иметь много аккаунтов для того что бы копировать нескольких трейдеров или торговать самостоятельно - торгуйте, копируйте, диверсифицируйте на едином аккаунте.`
                  }}
                </Determinator>
              </div>
            </Fade>
            <div className="icon">
              <svg ref={ref => { this.mainAccountRefs.clientIcon = ref }} className="client-icon" xmlns="http://www.w3.org/2000/svg" width="600" height="600" viewBox="0 0 600 600">
                <g id="Group_2202" transform="translate(-279 -5316)">
                  <g id="Ellipse_346" transform="translate(404 5441)" fill="none" stroke="#393939" strokeWidth="3" opacity="0.5">
                    <circle cx="175" cy="175" r="175" stroke="none" />
                    <circle cx="175" cy="175" r="173.5" fill="none" />
                  </g>
                  <g id="Group_2190" transform="translate(126 52)">
                    <path id="Subtraction_10" d="M15807.7,2537.395a120.593,120.593,0,0,1-24.124-2.432,119.053,119.053,0,0,1-42.8-18.01,120.034,120.034,0,0,1-43.365-52.663,119.061,119.061,0,0,1-6.975-22.469,120.878,120.878,0,0,1,0-48.247,119.056,119.056,0,0,1,18.01-42.8,120.035,120.035,0,0,1,52.663-43.367,119.059,119.059,0,0,1,22.469-6.975,120.865,120.865,0,0,1,48.247,0,119.068,119.068,0,0,1,42.8,18.011,120.053,120.053,0,0,1,43.367,52.663,119.2,119.2,0,0,1,6.975,22.469,120.878,120.878,0,0,1,0,48.247,119.036,119.036,0,0,1-18.011,42.8,120.032,120.032,0,0,1-52.665,43.366,119.089,119.089,0,0,1-22.468,6.974A120.591,120.591,0,0,1,15807.7,2537.395Zm-53.047-138.145a18.252,18.252,0,1,0,0,36.5,18,18,0,0,0,8.821-2.223,16.625,16.625,0,0,0,6.328-6.076l-7.751-4.5a7.15,7.15,0,0,1-2.974,2.974,9.9,9.9,0,0,1-11.2-1.547,10.453,10.453,0,0,1,0-13.75,9.895,9.895,0,0,1,11.2-1.551,7.228,7.228,0,0,1,2.974,2.926l7.752-4.453a16.907,16.907,0,0,0-6.353-6.048A17.9,17.9,0,0,0,15754.652,2399.25Zm60.446,10.049a12.908,12.908,0,0,0-13.3,13.251,12.65,12.65,0,0,0,3.825,9.426,14.021,14.021,0,0,0,10.173,3.725c4.679,0,8.3-1.564,10.753-4.649l-6-4.2a6.4,6.4,0,0,1-4.549,1.751c-2.887,0-4.771-1.026-5.6-3.05h17.248a13.909,13.909,0,0,0-3.3-12.5A12.4,12.4,0,0,0,15815.1,2409.3Zm49.9,8.65v7.451c0,3.948,1.019,6.716,3.026,8.226,1.436,1.082,3.66,1.631,6.611,1.631a33.044,33.044,0,0,0,3.861-.256v-7.5c-.52.028-1,.042-1.425.042a8.652,8.652,0,0,1-2.573-.289,1.9,1.9,0,0,1-1.2-2.051v-7.251h5.2V2410h-5.2v-7l-8.3,2.5v4.5h-3.749v7.951Zm-19.8-.8a3.759,3.759,0,0,1,2.723,1,3.961,3.961,0,0,1,1.027,2.95V2435h8.3v-14.95c0-3.451-.866-6.135-2.574-7.979a8.68,8.68,0,0,0-6.623-2.774c-3.12,0-5.459,1.077-6.951,3.2V2410h-8.3v25h8.3v-13.3a4.832,4.832,0,0,1,1.075-3.374A3.907,3.907,0,0,1,15845.2,2417.149Zm-56.5-7.151v25h8.3v-25Zm-14.35-11.5V2435h8.3v-36.5Zm18.5-.1a4.66,4.66,0,0,0-3.374,1.4,4.54,4.54,0,0,0-1.427,3.35,4.8,4.8,0,0,0,9.6,0,4.54,4.54,0,0,0-1.427-3.35A4.66,4.66,0,0,0,15792.85,2398.4Zm27.05,21.4h-9.6a4.8,4.8,0,0,1,1.748-2.626,5.308,5.308,0,0,1,3.148-.875,4.956,4.956,0,0,1,3.027.875,4.813,4.813,0,0,1,1.674,2.625Z" transform="translate(-15354.001 3146)" fill="#393939" />
                    <g id="Group_2189" transform="translate(0 0.001)">
                      <path ref={ref => { this.mainAccountRefs.topRight = ref }} style={{ opacity: 0 }} id="Subtraction_11" d="M15807.7,2417.7H15688V2298a120.582,120.582,0,0,1,24.124,2.432,119.044,119.044,0,0,1,42.8,18.011,120.056,120.056,0,0,1,43.366,52.664,119.067,119.067,0,0,1,6.975,22.469,120.609,120.609,0,0,1,2.432,24.122Zm-38.938-36.986a6.049,6.049,0,0,0-4.511,1.8,6.29,6.29,0,0,0,4.63,10.775,6.461,6.461,0,0,0,3.122-.742,5.725,5.725,0,0,0,2.158-2.015l-1.393-.817a3.857,3.857,0,0,1-1.5,1.476,4.734,4.734,0,0,1-2.364.563,4.948,4.948,0,0,1-3.226-1.067,4.346,4.346,0,0,1-1.552-2.892h10.537c.032-.318.048-.562.048-.746a6.591,6.591,0,0,0-1.643-4.451A5.47,5.47,0,0,0,15768.76,2380.711Zm-15.337,0a5.988,5.988,0,0,0-4.38,1.825,6.416,6.416,0,0,0,0,8.93,5.987,5.987,0,0,0,4.38,1.821,5.394,5.394,0,0,0,4.848-2.638V2393h1.587v-16.8h-1.587v7.153A5.389,5.389,0,0,0,15753.423,2380.711Zm-15.262,0a5.975,5.975,0,0,0-4.38,1.825,6.4,6.4,0,0,0,0,8.93,5.974,5.974,0,0,0,4.38,1.821,5.394,5.394,0,0,0,4.848-2.638V2393h1.583v-12h-1.583v2.353A5.389,5.389,0,0,0,15738.161,2380.711Zm39.073.29v12h1.583v-6.673a3.545,3.545,0,0,1,3.792-3.983v-1.539a3.913,3.913,0,0,0-3.792,2.186V2381Zm-51.364,0v12h1.587v-6.673a3.859,3.859,0,0,1,1.079-3.023,3.932,3.932,0,0,1,2.71-.96v-1.539a3.912,3.912,0,0,0-3.789,2.186V2381Zm-7.319-3.217V2393h1.683v-15.218h5.157V2376.2h-12v1.583Zm29.929-27.735h0V2365h1.683v-16.8h-1.44l-4.443,1.535.433,1.44,3.768-1.126Zm5.066,41.7a4.57,4.57,0,0,1-3.364-1.381,4.85,4.85,0,0,1,0-6.744,4.785,4.785,0,0,1,6.725,0,4.85,4.85,0,0,1,0,6.744A4.569,4.569,0,0,1,15753.546,2391.752Zm-15.266,0a4.566,4.566,0,0,1-3.36-1.381,4.837,4.837,0,0,1,0-6.744,4.78,4.78,0,0,1,6.721,0,4.84,4.84,0,0,1,0,6.744A4.569,4.569,0,0,1,15738.28,2391.752Zm34.8-5.495h-8.954a4.5,4.5,0,0,1,4.634-4.011,4.253,4.253,0,0,1,2.856,1.059,4.482,4.482,0,0,1,1.464,2.95Z" transform="translate(-15113 3046)" fill="#393939" />
                      <path ref={ref => { this.mainAccountRefs.bottomRight = ref }} style={{ opacity: 0 }} id="Subtraction_12" d="M15688,2417.7h0V2298h119.7a120.607,120.607,0,0,1-2.432,24.124,119.04,119.04,0,0,1-18.011,42.8,120.038,120.038,0,0,1-52.663,43.367,119.085,119.085,0,0,1-22.469,6.974A120.587,120.587,0,0,1,15688,2417.7Zm59.915-67.153a3.47,3.47,0,0,1,2.389.9,3.222,3.222,0,0,1,1,2.507c0,1.226-.872,2.719-2.591,4.439l-6.05,6.1V2366h10.68v-1.635h-8.28l4.8-4.772a15.484,15.484,0,0,0,2.3-2.833,5.355,5.355,0,0,0,.813-2.809,4.706,4.706,0,0,0-1.523-3.686,5.181,5.181,0,0,0-3.539-1.353,5.865,5.865,0,0,0-3.022.8,5.61,5.61,0,0,0-2.162,2.365l1.416.841A3.954,3.954,0,0,1,15747.916,2350.544Zm20.844-24.831a6.049,6.049,0,0,0-4.511,1.8,6.209,6.209,0,0,0-1.753,4.491,6.135,6.135,0,0,0,1.777,4.511,6.255,6.255,0,0,0,4.605,1.777,6.46,6.46,0,0,0,3.122-.746,5.7,5.7,0,0,0,2.158-2.015l-1.393-.817a3.855,3.855,0,0,1-1.5,1.476,4.732,4.732,0,0,1-2.364.563,4.93,4.93,0,0,1-3.226-1.067,4.329,4.329,0,0,1-1.552-2.892h10.537c.031-.3.048-.558.048-.742a6.6,6.6,0,0,0-1.643-4.455A5.468,5.468,0,0,0,15768.76,2325.714Zm-15.337,0a5.987,5.987,0,0,0-4.38,1.821,6.416,6.416,0,0,0,0,8.93,5.985,5.985,0,0,0,4.38,1.825,5.389,5.389,0,0,0,4.848-2.642V2338h1.587v-16.8h-1.587v7.153A5.386,5.386,0,0,0,15753.423,2325.714Zm-15.262,0a5.974,5.974,0,0,0-4.38,1.821,6.4,6.4,0,0,0,0,8.93,5.972,5.972,0,0,0,4.38,1.825,5.389,5.389,0,0,0,4.848-2.642V2338h1.583v-12h-1.583v2.353A5.386,5.386,0,0,0,15738.161,2325.714Zm39.073.286v12h1.583v-6.673a3.856,3.856,0,0,1,1.079-3.023,3.959,3.959,0,0,1,2.713-.96v-1.535a3.912,3.912,0,0,0-3.792,2.182V2326Zm-51.364,0v12h1.587v-6.673a3.858,3.858,0,0,1,1.079-3.023,3.944,3.944,0,0,1,2.71-.96v-1.535a3.911,3.911,0,0,0-3.789,2.182V2326Zm-7.319-3.214V2338h1.683v-15.214h5.157V2321.2h-12v1.587Zm35,13.965a4.586,4.586,0,0,1-3.364-1.376,4.85,4.85,0,0,1,0-6.744,4.785,4.785,0,0,1,6.725,0,4.85,4.85,0,0,1,0,6.744A4.583,4.583,0,0,1,15753.546,2336.75Zm-15.266,0a4.58,4.58,0,0,1-3.36-1.376,4.837,4.837,0,0,1,0-6.744,4.78,4.78,0,0,1,6.721,0,4.749,4.749,0,0,1-3.36,8.121Zm34.8-5.495h-8.954a4.491,4.491,0,0,1,4.634-4.007,4.265,4.265,0,0,1,2.856,1.055,4.485,4.485,0,0,1,1.464,2.95Z" transform="translate(-15113 3366)" fill="#393939" />
                      <path ref={ref => { this.mainAccountRefs.bottomLeft = ref }} style={{ opacity: 0 }} id="Subtraction_13" d="M15807.7,2417.7h-.017a120.5,120.5,0,0,1-24.106-2.431,119.047,119.047,0,0,1-42.8-18.01,120.062,120.062,0,0,1-43.368-52.663,119.225,119.225,0,0,1-6.975-22.469A120.631,120.631,0,0,1,15688,2298h119.7Zm-59.219-66.649h0V2366h1.683v-16.8h-1.44l-4.443,1.535.433,1.44,3.768-1.126Zm18.947-16.314h0l-1.344.793a4.129,4.129,0,0,0,1.694,1.992,5.415,5.415,0,0,0,2.939.77,4.9,4.9,0,0,0,3.13-.96,3.057,3.057,0,0,0,1.214-2.5,2.751,2.751,0,0,0-.722-1.979,4.068,4.068,0,0,0-1.749-1.079c-.714-.223-1.408-.421-2.063-.587a5.6,5.6,0,0,1-1.753-.746,1.484,1.484,0,0,1-.723-1.293,1.577,1.577,0,0,1,.746-1.4,3.155,3.155,0,0,1,1.777-.492,2.8,2.8,0,0,1,2.88,1.678l1.321-.765a4.063,4.063,0,0,0-1.635-1.79,4.915,4.915,0,0,0-2.566-.658,4.4,4.4,0,0,0-2.939.984,3.084,3.084,0,0,0-1.167,2.448,2.762,2.762,0,0,0,.723,1.979,4.042,4.042,0,0,0,1.749,1.079c.751.233,1.428.426,2.067.587a5.733,5.733,0,0,1,1.749.746,1.484,1.484,0,0,1,.723,1.293,1.572,1.572,0,0,1-.794,1.452,3.816,3.816,0,0,1-1.968.468,3.882,3.882,0,0,1-2.075-.54,2.809,2.809,0,0,1-1.214-1.476Zm-20.3-9.021a5.987,5.987,0,0,0-4.38,1.821,6.4,6.4,0,0,0,0,8.93,5.985,5.985,0,0,0,4.38,1.825,5.389,5.389,0,0,0,4.848-2.642V2338h1.583v-12h-1.583v2.353A5.386,5.386,0,0,0,15747.123,2325.714Zm31.416,1.821v7.272a3.023,3.023,0,0,0,1.262,2.833,4.324,4.324,0,0,0,2.214.492,10.505,10.505,0,0,0,1.567-.131v-1.393c-.625.026-1.162.038-1.6.038l-.325,0a1.527,1.527,0,0,1-1.154-.432,2.07,2.07,0,0,1-.385-1.4v-7.272h3.46V2326h-3.46v-3.36l-1.583.48V2326h-2.519v1.535Zm-60.385-6.336-6.455,16.8h1.777l1.56-4.129H15723l1.563,4.13h1.773l-6.455-16.8Zm43.707,4.8v12h1.583v-12Zm-4.943-5.519V2338h1.583v-17.519Zm-23.185,6.768a3.182,3.182,0,0,1,2.408.889,3.461,3.461,0,0,1,.853,2.5V2338h1.587v-7.367a5.03,5.03,0,0,0-1.261-3.59,4.549,4.549,0,0,0-3.444-1.329,4.445,4.445,0,0,0-4.03,2.158V2326h-1.587v12h1.587v-6.288a4.651,4.651,0,0,1,1.079-3.372A3.79,3.79,0,0,1,15733.733,2327.249Zm28.917-6.1a1.151,1.151,0,1,0,.817.337A1.1,1.1,0,0,0,15762.65,2321.151Zm-15.4,15.6a4.568,4.568,0,0,1-3.36-1.376,4.837,4.837,0,0,1,0-6.744,4.775,4.775,0,0,1,6.717,0,4.84,4.84,0,0,1,0,6.744A4.567,4.567,0,0,1,15747.246,2336.75Zm-24.843-4.463h-6.769l3.385-9,3.384,9Z" transform="translate(-15476 3366)" fill="#393939" />
                      <path ref={ref => { this.mainAccountRefs.topLeft = ref }} style={{ opacity: 0 }} id="Subtraction_14" d="M15807.7,2417.7H15688a120.6,120.6,0,0,1,2.432-24.123,119.021,119.021,0,0,1,18.012-42.8,120.05,120.05,0,0,1,52.664-43.368,119.1,119.1,0,0,1,22.468-6.975A120.558,120.558,0,0,1,15807.7,2298v119.7Zm-40.271-27.962h0l-1.344.794a4.133,4.133,0,0,0,1.694,1.991,5.416,5.416,0,0,0,2.939.766,4.882,4.882,0,0,0,3.13-.96,3.041,3.041,0,0,0,1.214-2.5,2.75,2.75,0,0,0-.722-1.979,4.015,4.015,0,0,0-1.749-1.079c-.65-.207-1.345-.4-2.063-.587a5.639,5.639,0,0,1-1.753-.746,1.5,1.5,0,0,1-.723-1.3,1.6,1.6,0,0,1,.746-1.4,3.182,3.182,0,0,1,1.777-.492,2.8,2.8,0,0,1,2.88,1.682l1.321-.77a4.075,4.075,0,0,0-1.635-1.785,4.909,4.909,0,0,0-2.566-.663,4.409,4.409,0,0,0-2.939.984,3.094,3.094,0,0,0-1.167,2.448,2.762,2.762,0,0,0,.723,1.98,4.1,4.1,0,0,0,1.749,1.083c.756.235,1.433.427,2.067.587a5.724,5.724,0,0,1,1.749.742,1.5,1.5,0,0,1,.723,1.3,1.579,1.579,0,0,1-.794,1.452,3.812,3.812,0,0,1-1.968.468,3.884,3.884,0,0,1-2.075-.539,2.84,2.84,0,0,1-1.214-1.476Zm-20.3-9.025a5.988,5.988,0,0,0-4.38,1.825,6.4,6.4,0,0,0,0,8.93,5.987,5.987,0,0,0,4.38,1.821,5.394,5.394,0,0,0,4.848-2.638V2393h1.583v-12h-1.583v2.353A5.389,5.389,0,0,0,15747.123,2380.711Zm31.416,1.825v7.272a3.022,3.022,0,0,0,1.262,2.833,4.322,4.322,0,0,0,2.214.492,10.5,10.5,0,0,0,1.567-.131v-1.393c-.625.026-1.162.038-1.6.038l-.325,0a1.527,1.527,0,0,1-1.154-.432,2.085,2.085,0,0,1-.385-1.4v-7.272h3.46V2381h-3.46v-3.36l-1.583.48V2381h-2.519v1.535Zm-60.385-6.336-6.455,16.8h1.777l1.56-4.129H15723l1.563,4.13h1.773l-6.455-16.8Zm43.707,4.8v12h1.583v-12Zm-4.943-5.522V2393h1.583v-17.523Zm-23.185,6.768a3.194,3.194,0,0,1,2.408.889,3.427,3.427,0,0,1,.853,2.5V2393h1.587v-7.371a5.024,5.024,0,0,0-1.261-3.586,4.534,4.534,0,0,0-3.444-1.333,4.447,4.447,0,0,0-4.03,2.162V2381h-1.587v12h1.587v-6.288a4.638,4.638,0,0,1,1.079-3.372A3.781,3.781,0,0,1,15733.733,2382.246Zm28.917-6.094a1.153,1.153,0,0,0-.813,1.968,1.155,1.155,0,0,0,1.631,0,1.152,1.152,0,0,0-.817-1.968Zm-14.734-26.608a3.408,3.408,0,0,1,2.389.9,3.222,3.222,0,0,1,1,2.507c0,1.226-.872,2.72-2.591,4.439l-6.05,6.1V2365h10.68v-1.635h-8.28l4.8-4.772a15.484,15.484,0,0,0,2.3-2.833,5.355,5.355,0,0,0,.813-2.809,4.706,4.706,0,0,0-1.523-3.686,5.179,5.179,0,0,0-3.539-1.353,5.865,5.865,0,0,0-3.022.8,5.61,5.61,0,0,0-2.162,2.365l1.416.841A3.95,3.95,0,0,1,15747.916,2349.544Zm-.67,42.207a4.553,4.553,0,0,1-3.36-1.381,4.837,4.837,0,0,1,0-6.744,4.775,4.775,0,0,1,6.717,0,4.84,4.84,0,0,1,0,6.744A4.552,4.552,0,0,1,15747.246,2391.752Zm-24.843-4.463h-6.769l3.385-9,3.384,9Z" transform="translate(-15476 3046)" fill="#393939" />
                    </g>
                  </g>
                  <g id="Ellipse_347" transform="translate(279 5316)" fill="none" stroke="#393939" strokeWidth="3" strokeDasharray="3" opacity="0.1">
                    <circle cx="300" cy="300" r="300" stroke="none" />
                    <circle cx="300" cy="300" r="298.5" fill="none" />
                  </g>
                </g>
              </svg>
            </div>
            <Slide bottom delay={1000}>
              <div className="button fcenter">
                <a href="https://dash.billtrade.io" target="_blank">
                  <Button
                    bodyStyle={{ background: '#393939', boxShadow: 'none' }}
                    textStyle={{ color: '#FFFFFF' }}
                  >
                    <Determinator>
                      {{
                        en: 'Join BillTrade',
                        ru: 'Присоединиться к BillTrade'
                      }}
                    </Determinator>
                  </Button>
                </a>
              </div>
            </Slide>
          </section>

          <section className="seven">
            <Slide cascade left duration={500}>
              <div className="title">
                <div className="lg">
                  <Determinator>
                    {{
                      en: 'About Bill Trade',
                      ru: 'О Bill Trade'
                    }}
                  </Determinator>
                </div>
                <div className="sm">
                  <Determinator>
                    {{
                      en: 'in numbers',
                      ru: 'в цифрах'
                    }}
                  </Determinator>
                </div>
              </div>
            </Slide>
            <div className="icon">
              <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="300" height="355.375" viewBox="0 0 331 355.375">
                <defs>
                  <linearGradient id="linear-gradient" x1="0.33" y1="1.037" x2="0.075" gradientUnits="objectBoundingBox">
                    <stop offset="0" stopColor="#ff4500" />
                    <stop offset="1" stopColor="#7fffd4" />
                  </linearGradient>
                </defs>
                <g id="Group_2711" transform="translate(-31 -4188)">
                  <path id="Path_4038" d="M22.926-175H40.5v79.86H20.074v-58.412L6.156-150.015,1.25-167.242ZM52.36-45.628q10.61,6.617,10.61,19.28,0,11.18-7.758,17.626T33.194-2.275q-14.375,0-22.133-6.446T3.3-26.347q0-12.663,10.61-19.28A18.779,18.779,0,0,1,6.042-61.6q0-11.18,7.644-17.455t19.509-6.275q11.751,0,19.394,6.332t7.644,17.4A18.779,18.779,0,0,1,52.36-45.628ZM33.194-66.847a8.344,8.344,0,0,0-5.761,1.882A6.329,6.329,0,0,0,25.322-60a6.288,6.288,0,0,0,2.111,5.02,8.512,8.512,0,0,0,5.761,1.825,8.218,8.218,0,0,0,5.59-1.882A6.252,6.252,0,0,0,40.952-60a6.252,6.252,0,0,0-2.168-4.963A8.218,8.218,0,0,0,33.194-66.847Zm0,45.862a10.222,10.222,0,0,0,6.845-2.225A7.449,7.449,0,0,0,42.663-29.2a7.577,7.577,0,0,0-2.624-6.1,10.222,10.222,0,0,0-6.845-2.225,10.174,10.174,0,0,0-6.9,2.225,7.654,7.654,0,0,0-2.567,6.1,7.523,7.523,0,0,0,2.567,5.989A10.174,10.174,0,0,0,33.194-20.985ZM43.233,40.05a24.955,24.955,0,0,1,12.321,8.214A21.693,21.693,0,0,1,60.232,62.3q0,12.892-8.442,19.851T30.912,89.107a33.912,33.912,0,0,1-17.626-4.563A25.914,25.914,0,0,1,2.163,71.082l17.8-10.154q2.51,8.328,10.952,8.328,4.335,0,6.674-2.054a6.925,6.925,0,0,0,2.339-5.476,6.755,6.755,0,0,0-2.339-5.419q-2.339-2-6.674-2H26.577L18.705,42.674l12.778-15.63H4.673V7.536H56.581V23.622ZM132.22,56.593v18.6h-7.986V87.4H103.927V75.189H68.9v-18.6L92.746,7.536h22.589L91.263,56.593h12.663V42.218h20.307V56.593ZM22.926,98.8H40.5v79.86H20.074V120.252L6.156,123.789,1.25,106.562Zm64.458,25.441q11.637,1.483,18.6,9.07t6.959,18.881q0,12.435-8.328,20.307t-21.9,7.872q-13.576,0-21.9-7.872T52.474,152.2a28.174,28.174,0,0,1,5.02-16.542L81.11,98.8h23.159Zm-4.677,37.42a10.109,10.109,0,0,0,7.016-2.51,8.874,8.874,0,0,0,2.8-6.959,9.113,9.113,0,0,0-2.738-7.073,10.059,10.059,0,0,0-7.073-2.51,10.059,10.059,0,0,0-7.073,2.51A9.113,9.113,0,0,0,72.9,152.2a8.931,8.931,0,0,0,2.738,7.016A10.2,10.2,0,0,0,82.707,161.665Zm35.48,17V163.833l26.468-27.951a66.453,66.453,0,0,0,5.818-7.016,9.4,9.4,0,0,0,1.825-5.3,6.373,6.373,0,0,0-1.882-4.792,7.142,7.142,0,0,0-5.191-1.825q-7.073,0-10.724,8.328l-17.569-9.811a29.133,29.133,0,0,1,11.409-13.69A30.94,30.94,0,0,1,145,97.093a29.6,29.6,0,0,1,19.566,6.788q8.157,6.788,8.157,18.539a26.068,26.068,0,0,1-3.251,12.835,60.506,60.506,0,0,1-9.526,12.378L149.1,158.927h24.985v19.737Zm85.792-40.614a20.4,20.4,0,0,1-14.945-5.989,20.451,20.451,0,0,1,0-29.035,20.505,20.505,0,0,1,14.945-5.932,20.122,20.122,0,0,1,14.831,5.932,20.728,20.728,0,0,1-.057,29.092A20.174,20.174,0,0,1,203.979,138.049Zm-9.127,28.065,52.479-57.043,7.986,4.563-52.593,56.928Zm9.013-42.554a5.593,5.593,0,0,0,4.278-1.768,6.037,6.037,0,0,0,1.654-4.278,5.839,5.839,0,0,0-1.654-4.221,5.686,5.686,0,0,0-4.278-1.711,5.548,5.548,0,0,0-4.164,1.711,5.839,5.839,0,0,0-1.654,4.221,5.984,5.984,0,0,0,1.654,4.335A5.548,5.548,0,0,0,203.865,123.561Zm44.265,56.7a20.454,20.454,0,0,1-15-5.932,20.657,20.657,0,0,1,0-29.092,20.454,20.454,0,0,1,15-5.932,20.36,20.36,0,0,1,20.763,20.535,19.616,19.616,0,0,1-5.989,14.489A20.174,20.174,0,0,1,248.13,180.261Zm-4.278-16.2a5.548,5.548,0,0,0,4.164,1.711A5.46,5.46,0,0,0,252.18,164a5.9,5.9,0,0,0,1.654-4.164,5.984,5.984,0,0,0-1.654-4.335,5.922,5.922,0,0,0-8.328,0,5.984,5.984,0,0,0-1.654,4.335A5.839,5.839,0,0,0,243.852,164.061Z" transform="translate(29.75 4363)" fill="url(#linear-gradient)" />
                  <text id="Profit_" transform="translate(309 4507)" fill="#9b9b9d" fontSize="18" fontFamily="Gilroy-Regular, Gilroy" letterSpacing="0.025em"><tspan x="0" y="0">
                    <Determinator>
                      {{
                        en: `Profit*`,
                        ru: `Прибыль*`
                      }}
                    </Determinator>
                  </tspan></text>
                  <text id="Users" transform="translate(192 4412)" fill="#9b9b9d" fontSize="18" fontFamily="Gilroy-Regular, Gilroy" letterSpacing="0.025em"><tspan x="0" y="0">
                    <Determinator>
                      {{
                        en: `Users`,
                        users: `Пользователей`,
                      }}
                    </Determinator>
                  </tspan></text>
                  <text id="Traders" transform="translate(118 4321)" fill="#9b9b9d" fontSize="17" fontFamily="Gilroy-Regular, Gilroy" letterSpacing="0.025em"><tspan x="0" y="0">
                    <Determinator>
                      {{
                        en: `Traders`,
                        traders: `Трейдеров`,
                      }}
                    </Determinator>
                  </tspan></text>
                  <text id="The_funds_use" data-name="The funds use" transform="translate(76 4235)" fill="#9b9b9d" fontSize="17" fontFamily="Gilroy-Regular, Gilroy" letterSpacing="0.025em"><tspan x="0" y="0">
                    <Determinator>
                      {{
                        en: `Used by funds`,
                        ru: `Используется фондами `,
                      }}
                    </Determinator>
                  </tspan></text>
                </g>
              </svg>
            </div>
          </section>

          <section className="eight">
            <Slide cascade left duration={500}>
              <div className="title">
                <div className="lg">
                  <Determinator>
                    {{
                      en: 'Affiliate program',
                      ru: 'Партнерская программа'
                    }}
                  </Determinator>
                </div>
                <div className="sm">
                  <Determinator>
                    {{
                      en: 'Invite a friend to join Bill Trade',
                      ru: 'Пригласите друга присоединиться к BillTrade'
                    }}
                  </Determinator>
                </div>
              </div>
            </Slide>
            <Slide cascade left duration={500}>
              <div className="body">

                <div className="item">
                  <div className="level">
                    <span className="label">
                      <Determinator>
                        {{
                          en: 'Lv',
                          ru: 'Ур'
                        }}
                      </Determinator>
                    </span>
                    <span className="number">
                      1
                      </span>
                  </div>
                  <div className="description">
                    <Determinator>
                      {{
                        en: 'Get 3% of the profit he makes on Bill Trade as an investor',
                        ru: 'Получайте 3% от прибыли, которую он получает от платформы как инвестор'
                      }}
                    </Determinator>
                  </div>
                </div>

                <div className="item">
                  <div className="level">
                    <span className="label">
                      <Determinator>
                        {{
                          en: 'Lv',
                          ru: 'Ур'
                        }}
                      </Determinator>
                    </span>
                    <span className="number">
                      2
                      </span>
                  </div>
                  <div className="description">
                    <Determinator>
                      {{
                        en: 'If he invites a friend, you’ll get 2% of his friend’s profit',
                        ru: 'Если он пригласит друга, вы будете получать 2% от прибыли его друга'
                      }}
                    </Determinator>
                  </div>
                </div>

                <div className="item">
                  <div className="level">
                    <span className="label">
                      <Determinator>
                        {{
                          en: 'Lv',
                          ru: 'Ур'
                        }}
                      </Determinator>
                    </span>
                    <span className="number">
                      3
                      </span>
                  </div>
                  <div className="description">
                    <Determinator>
                      {{
                        en: 'You’ll also benefit in case the last one invites his friend - 1% of the profit.',
                        ru: 'Если последний пригласит своего друга, вы будете получать 1% от его прибыли'
                      }}
                    </Determinator>
                  </div>
                </div>


              </div>
            </Slide>
            {/* end of body */}

            <Zoom left>
              <div className="text">
                <Determinator>
                  {{
                    en: 'If a trader joins Bill Trade via your affiliate link, you’ll get 1% of his profit.',
                    ru: 'Если трейдер присоединится к BillTrade по вашей партнерской ссылке, вы будете получать 1% от его прибыли'
                  }}
                </Determinator>
              </div>
            </Zoom>

            <div className="button">
              {/* <Bounce bottom>
                <Button
                  bodyStyle={{ background: '#393939', boxShadow: 'none' }}
                  textStyle={{ color: '#FFFFFF' }}
                >
                  <Determinator>
                    {{
                      en: 'Invite friends',
                      ru: 'Пригласить друзей'
                    }}
                  </Determinator>
                </Button>
              </Bounce> */}
            </div>
          </section>

          <section className="nine">
            <div className="title">
              <Slide left>
                <Determinator>
                  {{
                    en: 'Bill Trade benefits',
                    ru: 'Преимущества'
                  }}
                </Determinator>
              </Slide>
            </div>
            <div className="subtitle">
              <Fade top>
                <Determinator>
                  {{
                    en: 'Copy trading via wallets',
                    ru: 'Копирование сделок используя кошельки '
                  }}
                </Determinator>
              </Fade>
            </div>

            <div className="description">
              <Fade top>
                <Determinator>
                  {{
                    en: `Trade any crypto asset with Bill Trade even if the exchange you're using doesn't have it. Simply find it on the Bill Trade exchange, deposit funds and start trading.`,
                    ru: 'Торгуйте любым крипто активом с помощью Bill Trade, даже если у используемой вами биржи его нет. Просто найдите его на бирже Bill Trade, внесите средства и начните торговать.'
                  }}
                </Determinator>
              </Fade>
            </div>

            <Fade cascade top>
              <div className="body">
                <div className="item">
                  <Determinator>
                    {{
                      en: 'Zero delay',
                      ru: 'Нулевая задержка'
                    }}
                  </Determinator>
                </div>
                <div className="item">
                  <Determinator>
                    {{
                      en: 'Real-time trading history',
                      ru: 'История торговли в реальном времени'
                    }}
                  </Determinator>
                </div>
                <div className="item">
                  <Determinator>
                    {{
                      en: 'The platform is free to use.',
                      ru: 'Бесплатное использование сервисов платформы'
                    }}
                  </Determinator>
                </div>
                <div className="item">
                  <Determinator>
                    {{
                      en: 'Position entry slip control system',
                      ru: 'Система регулирования проскальзывания входа в позицию'
                    }}
                  </Determinator>
                </div>
                <div className="item">
                  <Determinator>
                    {{
                      en: 'Smart system of buy/sell balance',
                      ru: 'Умная система покупки продажи активов'
                    }}
                  </Determinator>
                </div>
              </div>
            </Fade>

            <Bounce bottom>
              <a className="button" href="https://dash.billtrade.io" target="_blank">
                <Button
                  bodyStyle={{ background: '#393A3E' }}
                  textStyle={{ color: '#fff' }}
                >
                  <Determinator>
                    {{
                      en: 'Open free account',
                      ru: 'Открыть бесплатный аккаунт'
                    }}
                  </Determinator>
                </Button>
              </a>
            </Bounce>
          </section>

          <footer>
            <div className="title">
              <Determinator>
                {{
                  en: 'Feel free to contact us',
                  ru: 'Связаться с нами'
                }}
              </Determinator>
            </div>
            <div className="description">
              <Determinator>
                {{
                  en: 'We are glad to help you 24 hours a day, 7 days a week. Just write us a letter and we’ll answer you as soon as possible!',
                  ru: 'Наша клиентская поддержка доступна 24/7. Для оперативного решения вопросов просто создайте заявку в личном кабинете.'
                }}
              </Determinator>
            </div>

            <form action="">
              <input type="text" placeholder={emailPlaceholder} />
              <textarea placeholder={areaPlaceholder} name="" id="" cols="30" rows="10"></textarea>
              <Button>
                <Determinator>
                  {{
                    en: 'Send',
                    ru: 'Отправить'
                  }}
                </Determinator>
              </Button>
            </form>

            <div className="socials">
              <a className="item" href="https://www.facebook.com/BillTrade.io/" target="_blank">
                <img
                  className="icon"
                  src={process.env.PUBLIC_URL + '/facebook.svg'}
                  alt=""
                />
              </a>
              <a className="item" href="https://t.me/BillTrade" target="_blank">
                <img
                  className="icon"
                  src={process.env.PUBLIC_URL + '/telegram.svg'}
                  alt=""
                />
              </a>
              <a className="item" href="https://www.instagram.com/billtrade_io/" target="_blank">
                <img
                  className="icon"
                  src={process.env.PUBLIC_URL + '/instagram.svg'}
                  alt=""
                />
              </a>
              <a className="item" href="https://www.linkedin.com/company/bill-trade/" target="_blank">
                <img
                  className="icon"
                  src={process.env.PUBLIC_URL + '/linkeding.svg'}
                  alt=""
                />
              </a>
            </div>

            <div className="menu">
              <div className="item">
                <img src={process.env.PUBLIC_URL + '/mobile/Logo.svg'} />
              </div>
              <div className="item">
                <a
                  href="/Wiki.pdf"
                  target="_blank"
                  className="link"
                >
                  Wiki
                </a>
              </div>
              <div className="item">
                <a
                  href="/Terms.pdf"
                  target="_blank"
                  className="link"
                >
                  Terms & conditions
                </a>
              </div>
              <div className="item">
                <a
                  href="/Privacy.pdf"
                  target="_blank"
                  className="link"
                >
                  Privacy Policy
                </a>
              </div>
            </div>

            <div className="detection">
              You should not invest funds that you wouldn’t be able to lose. You should be advised from an independent and reputable licensed financial advisor, before deciding to trade to let you know all the risks associated with this practise (Trading). We shall not be responsible to any person or entity for any losses or damages particularly or in whole, related to any transactions (direct, indirect, special, consequential or incidental damages whatsoever). The previous good results of any trader on our platform  is not a sure indicator of his future performance. The content that you see on our platform is created by the users of BillTrade and does not contain advices or recommendations on behalf of BillTrade.
            </div>

            <div className="rights">
              <div className="text">
                <Determinator>
                  {{
                    en: 'Bill Trade. 2019 all rights reserved',
                    ru: 'Bill Trade. 2019 все права защищены'
                  }}
                </Determinator>
              </div>
            </div>
          </footer>
        </main>
      </div>
    )
  }
}

const Mobile = withLang({
  en: {
    emailPlaceholder: 'Enter your E-mail',
    areaPlaceholder: 'Write your question here',
    items: [
      {
        title: `Total freedom for the traders`,
        top: {
          title: `Trade where ever you want -  Earn with Bill Trade`,
          subtitle: `You can use any programs,
          signals, terminals to signal on our platform`
        },
        bottom: {
          title: `No trading barriers `,
          subtitle: `Trade using any type of order, 
          leverage and asset`
        },
      },
      {
        title: `Analyst`,
        top: {
          title: `Quality copying`,
          subtitle: `Analyst - Creates his own copying strategy and shares it with the other users of the platform.`
        },
        bottom: {
          title: `The best results`,
          subtitle: `By analyzing the statistic of the trader, an analyst can enhance his copying results, as well as dynamically change the allocated percentage and the numbers of traders in his portfolio`
        },
      },
      {
        title: `Multiplier`,
        top: {
          title: `Risk management`,
          subtitle: `The ability to adjust risks (Profit and loss) relative to the trader. You can make a conservative trader aggressive and vice versa.`
        },
        bottom: {
          title: `Good diversification`,
          subtitle: `The ability to level the average profitability of traders and combine them into one portfolio`
        },
      }
    ]
  },
  ru: {
    emailPlaceholder: 'Введите ваш E-mail',
    areaPlaceholder: 'Задайте нам вопрос',
    items: [
      {
        title: `Полная свобода для трейдеров`,
        top: {
          title: `Торгуйте, где хотите - зарабатывайте с Bill Trade`,
          subtitle: `Вы можете использовать любые программы, сигналы, терминалы чтобы транслировать на нашей платформе`
        },
        bottom: {
          title: `Никаких торговых ограничений`,
          subtitle: `Торгуйте любым типом ордера, плечем и активом`
        },
      },
      {
        title: `Аналитик`,
        top: {
          title: `Качественное копирование`,
          subtitle: `Аналитик - Создаёт свои стратегии копирования и транслирует их для дрыгих клиентов`
        },
        bottom: {
          title: `Лучшие результаты`,
          subtitle: `Анализируя статистику трейдера, аналитик может улучшить результат копирования, а так же динамически изменять процент и количество трейдеров в своем портфеле`
        },
      },
      {
        title: `Множитель`,
        top: {
          title: `Эффективный риск менеджмент `,
          subtitle: `Возможность регулировать риски(Прибыли и убытки) относительно трейдера. Вы можете из консервативного трейдера сделать - агрессивного и наоборот.`
        },
        bottom: {
          title: `Хорошая диверсификация`,
          subtitle: `Возможность уровнять среднюю доходность трейдеров и обьеденить их в один портфель`
        },
      }
    ]
  }
})(MobileNoLang);

export default Mobile;